export default __webpack_public_path__ + "static/media/white_cross.629f8a80.svg";